import { useEffect, useState } from "react";
import { getInlineLoader } from "../Helpers";

import projectPartners from "../assets/p_partners.jpg";
import businessPartners from "../assets/b_partners.jpg";

export default function Partners() {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    setReady(true);
  }, []);

  if (!ready) {
    return (
      <div className="container mSupportLoading">
        {getInlineLoader()}
      </div>
    );
  }

  return (
    <section
      className="MainBodySection py-5"
      style={{
        background:
          "radial-gradient(circle at 90% 10%, rgba(7, 135, 90, 0.10), transparent 34%), linear-gradient(180deg, #f6fbf8 0%, #ffffff 100%)",
      }}
    >
      <div className="container" style={{ maxWidth: 1140 }}>
        <div className="text-center mb-4 mb-lg-5">
          <h2 className="font-bold text-primary mb-2">Our Partners</h2>
          <p className="text-muted mb-0">
            We collaborate with trusted organizations and business allies to strengthen food security,
            expand farmer access to quality inputs, and deliver long-term impact.
          </p>
        </div>

        <div className="row g-4 align-items-stretch">
          <div className="col-lg-6">
            <article
              className="h-100 overflow-hidden p-2 p-md-5"
              style={{
                borderRadius: "22px",
                background: "#ffffff",
                border: "1px solid rgba(15, 23, 42, 0.08)",
                boxShadow: "0 14px 32px rgba(15, 23, 42, 0.09)",
              }}
            >
              <img
                src={projectPartners}
                alt="Project Partners"
                style={{ width: "100%", height: "260px", objectFit: "cover", display: "block" }}
              />
              <div className="p-4 p-lg-5">
                <div
                  className="font-semi-bold mb-2"
                  style={{
                    letterSpacing: "0.08em",
                    textTransform: "uppercase",
                    fontSize: "0.78rem",
                    color: "rgba(7, 135, 90, 0.9)",
                  }}
                >
                  Project Partners
                </div>
                <p className="text-muted mb-0" style={{ lineHeight: 1.72 }}>
                  Our project partners support research, innovation, and community-focused programs that
                  improve productivity and nutrition across Tanzania.
                </p>
              </div>
            </article>
          </div>

          <div className="col-lg-6">
            <article
              className="h-100 overflow-hidden p-2 p-md-5"
              style={{
                borderRadius: "22px",
                background: "#ffffff",
                border: "1px solid rgba(15, 23, 42, 0.08)",
                boxShadow: "0 14px 32px rgba(15, 23, 42, 0.09)",
              }}
            >
              <img
                src={businessPartners}
                alt="Business Partners"
                style={{ width: "100%", height: "260px", objectFit: "cover", display: "block" }}
              />
              <div className="p-4 p-lg-5">
                <div
                  className="font-semi-bold mb-2"
                  style={{
                    letterSpacing: "0.08em",
                    textTransform: "uppercase",
                    fontSize: "0.78rem",
                    color: "rgba(7, 135, 90, 0.9)",
                  }}
                >
                  Business Partners
                </div>
                <p className="text-muted mb-0" style={{ lineHeight: 1.72 }}>
                  We work with business partners to ensure dependable supply chains, quality assurance,
                  and distribution of agricultural inputs nationwide.
                </p>
              </div>
            </article>
          </div>
        </div>
      </div>
    </section>
  );
}
